const imgZip = (url, w, h, isSupportWebp) => {
  // return url + `!${w}x${h}`
  if (!url) return url

  // base64
  if (url.indexOf('data') === 0) return url

  // gif加压缩参数之后不会动
  if (url.indexOf('.gif') > -1) return url

  // 如果压缩过了，就不压缩了
  if ((!w && !h) || url.indexOf('!') > -1) {
    return url
  }

  if (url.indexOf('x-oss-process=image') > -1) {
    return url + (isSupportWebp ? '/format,webp' : '')
  }

  return (
    url +
    `?x-oss-process=image/resize` +
    (w ? `,w_${w}` : '') +
    (h ? `,h_${h}` : '') +
    (isSupportWebp ? '/format,webp' : '')
  )
}

const imgCut = (url, w, h) => {
  // return url + `!${w}x${h}`
  // 如果压缩过了，就不压缩了
  let urlObj = new URL(url)
  if ((!w && !h) || url.indexOf('x-oss-process=image') > -1) {
    return url
  }
  if (urlObj.search !== '') {
    urlObj.search = `${urlObj.search}&x-oss-process=image/resize,m_fill${
      w ? `,w_${w}` : ''
    }${h ? `,h_${h}` : ''}`
  } else {
    urlObj.search =
      `?x-oss-process=image/resize,m_fill` +
      (w ? `,w_${w}` : '') +
      (h ? `,h_${h}` : '')
  }
  return urlObj.href
}

export { imgZip, imgCut }

export default {
  imgZip,
  imgCut
}
